import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { CouponsV2BenefitListItemExtension } from './coupons-v2-benefit-list-item.extension';
import { CouponsV2BenefitMetadataExtension } from './coupons_v2-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('coupons_v2')
    .add(BenefitMetadataExtensionInterface, new CouponsV2BenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new CouponsV2BenefitListItemExtension())
    .build(),
);
